export function applyMixins(derivedConstructor: any, baseConstructors: any[]) {

    baseConstructors.forEach(baseConstructor => {
        Object.getOwnPropertyNames(baseConstructor.prototype)
            .forEach(name => {
                const originalFn = Object.getOwnPropertyDescriptor(
                    baseConstructor.prototype,
                    name
                );
                // On n'ecrase pas les methodes existante
                if (!Object.getOwnPropertyDescriptor(derivedConstructor.prototype, name)) {
                    Object.defineProperty(derivedConstructor.prototype,
                        name, originalFn
                    );
                }
            });
    });
}
